import { Flex } from "@aircall/tractor";

import { PlayerSpeakerTimeline } from "../PlayerSpeakerTimeline";

import {
  SegmentData,
  useSegmentsPerSpeaker,
  useSortSpeakers,
} from "./PlayerSpeakersList.hooks";

import { SpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";
import { useCall } from "@/hooks/useCall/useCall";
import { useSpeakerColor } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";
import { Call } from "@/states/call";
import { SpeakersType } from "@/states/call/speakers/speakers.utility.decl";
import { Maybe } from "graphql/jsutils/Maybe";

export function SpeakerItem({
  channel,
  segments,
  call,
}: {
  channel: number;
  segments: SegmentData[];
  call: Maybe<Call>;
}) {
  const color = useSpeakerColor(channel);
  return (
    <>
      <Flex gridColumn={1} justifyContent="flex-end">
        <SpeakerAvatar channel={channel} />
      </Flex>
      <PlayerSpeakerTimeline call={call} segments={segments} color={color} />
    </>
  );
}

export function PlayerSpeakersList({
  speakers,
}: {
  speakers: NonNullable<SpeakersType>;
}) {
  const speakersSegments = useSegmentsPerSpeaker(speakers);
  const sortedSpeakers = useSortSpeakers(speakersSegments, speakers);
  const { call } = useCall();

  return (
    <>
      {sortedSpeakers.map(({ channel, segments }) => (
        <SpeakerItem
          key={channel}
          segments={segments}
          channel={channel}
          call={call}
        />
      ))}
    </>
  );
}
